import { searchQuestions, ISiteMapNode, mapCurrentPageToPageGroup } from '@bingads-webui/search-utils';

// do not show troubleshooting questions in global search or help
const options = {
  isTroubleshootingEnabled: false,
};

export function getSearchQuestionsFromSiteMap(siteMap: ISiteMapNode[], i18n: any) {
  return searchQuestions(mapCurrentPageToPageGroup(siteMap), i18n, true, options);
}

export function getSearchQuestionsFromQuery(query: string, i18n: any) {
  return searchQuestions(query, i18n, false, options);
}
